export const BASE_URL = "https://rise-backend.ideassionlive.in";

export const IMAGE_BASE_URL = "https://rise-backend.ideassionlive.in";
